// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'babel-polyfill'
// import promise from 'es5-promise'
// promise.polyfill()
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'

import qs from "qs" 
import '../src/assets/css/reset.css'
import '../src/assets/css/golobal.css'
import ElementUI from 'element-ui';
import 'babel-polyfill'
import 'element-ui/lib/theme-chalk/index.css';
import moment from 'moment'; //导入模块
import toBannerActive from "./config/toActive"
import toGoodslis from "./config/toDetails"  
import scroll from 'vue-seamless-scroll' 
import goodsAdd from './config/goodsAdd'
import goodsLable from './config/getLabel'
import VueVideoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css';
import selfImg from '@/config/selfImg.js' // 自定义图片组件
import "../src/axios/apiUrl";



Vue.use(selfImg)
Vue.use(VueVideoPlayer);
Vue.use(scroll) 
//定义全局过滤器实现日期格式化
Vue.filter("format", function(input, fmtstring) {
  // 使用momentjs这个日期格式化类库实现日期的格式化功能
  return moment(input).format(fmtstring);
});
Vue.prototype.$moment = moment;//赋值使用

Vue.prototype.toBannerActive = toBannerActive //
Vue.prototype.toGoodslis = toGoodslis //
// 数量加减
Vue.prototype.goodsAdd = goodsAdd;
Vue.prototype.goodsLable = goodsLable;
Vue.config.productionTip = false


Vue.use(ElementUI);
Vue.prototype.$http = axios;
Vue.prototype.imgBaseUrl = "https://image.hezongyy.com/pcimage/";

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js